import { roiIndustryOptions } from '@components/SectionComponents/ROICalculator/ROIIndustryOptions';
import { Unit } from '@models/ROICalculator';
import { atom } from 'jotai';

export const roiIndustryValueAtom = atom(roiIndustryOptions[0]);

export const roiUnitSystemAtom = atom(Unit.Imperial);
